import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Document, pdfjs, Page } from 'react-pdf';
import ProposalFeedbacks from '../../ProposalFeedbacks';
import loading from '../../../../assets/images/spinner-DNA-2s-200px.svg';
import './Resume.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const cloraSpinner = () => (
  <div className="loading">
    <img src={loading} alt="Loading_image" />
  </div>
);

function Resume({
  document, originalDocument, returnPath, returnText, showHeader,
  isSignedIn, admin, canEditFeedback, ownerName, candidateName,
  proposalResourceId, id, consultantFit, note, csrfToken, email, feedbacks,
}) {
  const width = Math.min(window.innerWidth, 768);
  const [numPages, setNumPages] = useState();
  function onDocumentLoadSuccess(proxy) {
    setNumPages(proxy._pdfInfo.numPages);
  }
  const pages = [];
  for (let i = 1; i <= numPages; i += 1) { pages.push(i); }

  return (
    <Document
      file={document}
      loading={cloraSpinner()}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {
        showHeader
        && (
        <div className="header-buttons row">
          <div className="return-link col-sm-4">
            { returnPath
              ? (
                <div className="back-to-project style-guide">
                  <a className="body-text-2 medium-weight" href={returnPath}>
                    <i className="fa fa-chevron-left" />
                    { returnText }
                  </a>
                </div>
              ) : ''}
          </div>
          <div className="col-sm-4" />
          <div className="download-section col-sm-4">
            { admin
              && (
              <a className="btn btn-secondary" href={originalDocument}>
                Download File
              </a>
              )}
          </div>
        </div>
        )
      }
      { isSignedIn && !admin && consultantFit === null && proposalResourceId && canEditFeedback
        && (
        <div className="row">
          <div className="feedback-section col-sm-12">
            <ProposalFeedbacks
              isSignedIn={isSignedIn}
              admin={admin}
              canEditFeedback={canEditFeedback}
              ownerName={ownerName}
              candidateName={candidateName}
              proposalResourceId={proposalResourceId}
              id={id}
              consultantFit={consultantFit}
              note={note}
              csrfToken={csrfToken}
              email={email}
              feedbacks={feedbacks}
              location="resume"
            />
          </div>
        </div>
        )}
      <div className="row resume-container">
        { pages.map((pageNum) => (
          <Page
            renderAnnotationLayer={false}
            renderTextLayer={false}
            pageNumber={pageNum}
            width={width}
          />
        ))}
      </div>
    </Document>
  );
}

Resume.propTypes = {
  document: PropTypes.string.isRequired,
  originalDocument: PropTypes.string.isRequired,
  returnPath: PropTypes.string,
  returnText: PropTypes.string,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})),
  isSignedIn: PropTypes.bool,
  admin: PropTypes.bool,
  canEditFeedback: PropTypes.bool,
  ownerName: PropTypes.string,
  candidateName: PropTypes.string,
  proposalResourceId: PropTypes.string,
  id: PropTypes.string,
  consultantFit: PropTypes.string,
  note: PropTypes.string,
  csrfToken: PropTypes.string,
  email: PropTypes.string,
  showHeader: PropTypes.bool,
};

Resume.defaultProps = {
  returnPath: null,
  returnText: 'Back to Proposal',
  feedbacks: [],
  isSignedIn: false,
  admin: false,
  canEditFeedback: false,
  ownerName: '',
  candidateName: '',
  proposalResourceId: '',
  id: '',
  consultantFit: '',
  note: '',
  csrfToken: '',
  email: '',
  showHeader: true,
};

export default Resume;
